module.exports = __webpack_public_path__ + "img/1725849578317-screenshot-1725849557736.png.af185ce1.webp";